<template>
  <v-items-layout />
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapMutations, mapState } = createNamespacedHelpers(
  "classifier"
);

import VItemsLayout from "../Layout";

/**
 * We reuse the same layout of the items but this view sets the validated flag
 * to get the already validated items.
 */
export default {
  components: {
    VItemsLayout
  },
  computed: {
    ...mapState(["currentClassification", "items", "loadingItems"])
  },
  methods: {
    ...mapActions(["getItems", "setCurrentClassification"]),
    ...mapMutations(["setGetValidatedItems"])
  },
  created() {
    this.setGetValidatedItems(true);
    if (
      this.currentClassification &&
      !this.loadingItems &&
      !this.items.length
    ) {
      this.getItems();
    }
  },
  beforeDestroy() {
    this.setGetValidatedItems(false);
  },
  watch: {
    currentClassification() {
      this.getItems();
    },
    "$route.params.classificationId"() {
      this.setCurrentClassification(this.$route.params.classificationId);
    }
  }
};
</script>